import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Hero.css";

const Hero = () => {
  return (
    <>
      {/* SEO Meta Tags + Local Business Structured Data */}
      <Helmet>
        <title>Advanced Healthcare in Indapur | First Modular OT | Dr. Chavan Multi-Speciality Hospital</title>
        <meta
          name="description"
          content="Dr. Chavan Multi-Speciality Hospital in Indapur offers expert surgical, gynaecology, and multidisciplinary care with the first Modular OT in Indapur."
        />
        <meta
          name="keywords"
          content="Indapur hospital, first modular OT, multi-speciality hospital, surgical care, gynaecology, best hospital in Indapur"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Advanced Healthcare in Indapur | First Modular OT | Dr. Chavan Multi-Speciality Hospital" />
        <meta property="og:description" content="Providing expert surgical, gynaecology, and multidisciplinary care in Indapur with the first Modular OT and compassionate treatment." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://drchavanhospital.in/" />
        <meta property="og:image" content="https://drchavanhospital.in/images/hero.jpeg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Advanced Healthcare in Indapur | First Modular OT | Dr. Chavan Multi-Speciality Hospital" />
        <meta name="twitter:description" content="Expert surgical, gynaecology, and multidisciplinary care in Indapur with the first Modular OT and compassionate treatment." />
        <meta name="twitter:image" content="https://drchavanhospital.in/images/hero.jpeg" />

        {/* Local Business Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Dr. Chavan Multi-Speciality Hospital",
              "image": "https://drchavanhospital.in/images/hero.jpeg",
              "url": "https://drchavanhospital.in/",
              "telephone": "+91-XXXXXXXXXX",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Your Street Address",
                "addressLocality": "Indapur",
                "addressRegion": "Maharashtra",
                "postalCode": "413106",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "XX.XXXXXX",
                "longitude": "XX.XXXXXX"
              },
              "openingHours": "Mo-Su 08:00-20:00",
              "medicalSpecialty": ["Surgery", "Gynaecology", "Laparoscopy", "Endoscopy", "Modular OT"]
            }
          `}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="hero" role="banner" aria-label="Hero Section - Dr. Chavan Multi-Speciality Hospital Indapur">
        <div className="hero-content">
          <h1
            className="hero-title"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Advanced Healthcare in Indapur, <span className="highlighty">Trusted by Families</span>
          </h1>
          <p
            className="hero-subtitle"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            At <strong>Dr. Chavan Multi-Speciality Hospital</strong>, we provide expert <strong>surgical care</strong>, <strong>gynaecology</strong>, and <strong>multidisciplinary treatments</strong> using modern technology and compassionate patient care. 
            <span className="highlighty">We are proud to have the 1st Modular OT in Indapur</span>. Schedule your consultation and experience <strong>quality healthcare in Indapur</strong>.
          </p>
          <div
            className="hero-buttons"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <Link
              to="/contact"
              className="btn-primary"
              data-aos="zoom-in"
              data-aos-delay="700"
              aria-label="Book an Appointment at Dr. Chavan Multi-Speciality Hospital Indapur"
            >
              Book an Appointment
            </Link>
            <Link
              to="/services"
              className="btn-secondary"
              data-aos="zoom-in"
              data-aos-delay="800"
              aria-label="Explore Services offered by Dr. Chavan Multi-Speciality Hospital Indapur"
            >
              Explore Our Services
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
